/**
 * Shared rules for which code grid columns are hidden in the UI.
 * Used by column rendering (commonColumns) and keyboard Tab order (encounterCodeGrid).
 */
export interface CodeGridColumnVisibilityOptions {
  isPracticeMode?: boolean;
  isInPatient?: boolean;
  isAPRDrgGrouper?: boolean;
  showGrouperFlagOnOP?: boolean;
}

export const isCodeGridColumnHidden = (
  opts: CodeGridColumnVisibilityOptions,
  columnId: string,
): boolean => {
  // GF column must be hidden for OP modes
  if (!opts.isInPatient && columnId === "colGrouperFlag" && !opts.showGrouperFlagOnOP) {
    return true;
  }

  // SOI and ROM columns must be shown only for the APR Drg grouper
  if (!opts.isAPRDrgGrouper && (columnId === "colSOI" || columnId === "colROM")) {
    return true;
  }

  const hiddenOutsidePracticeMode = [
    "colFeeAmount",
    "colTotalRVU",
    "colWorkRVU",
    "colNonFacilityPracExpRVU",
    "colMalpracticeRVU",
    "colFacilityPracExpRVU",
    "colPlaceOfService",
  ];
  if (!opts.isPracticeMode && hiddenOutsidePracticeMode.includes(columnId)) {
    return true;
  }

  const hiddenInPracticeMode = [
    "colFacilityFeeAmount",
    "colTotalFacilityRVU",
    "colPresentOnAdmission",
  ];
  if (opts.isPracticeMode && hiddenInPracticeMode.includes(columnId)) {
    return true;
  }

  return false;
};
